export const WEATHER_CATEGORY_COLORS: Readonly<Record<string, string>> = {
  Cold: '#43729c',
  Fire: '#c95c3e',
  Flood: '#258f84',
  Fog: '#88919e',
  Heat: '#d58e2e',
  Marine: '#2f6f98',
  Storm: '#344d66',
  'Tropical Cyclone': '#76568d',
  Wind: '#7368af',
  'Winter Weather': '#75a6c0',
  Other: '#9b7b62',
  Unmapped: '#b3a78e',
  Multiple: '#636b72',
  Tie: '#8d8374',
};
